import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconElectrocardiogram: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconElectrocardiogram"><Path d="M1.5 12H6L9 3L15 21.25L18 12H22.25" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconElectrocardiogram;
